import type { ComponentType } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AnalyticsInitializer } from '../components';

interface CreateGameAppParams {
  AuthLayout: ComponentType;
  GameLayout: ComponentType;
}

// Shared game shell: router + analytics. /auth shows AuthLayout, the rest GameLayout.
export function createGameApp({ AuthLayout, GameLayout }: CreateGameAppParams) {
  return function App() {
    return (
      <BrowserRouter>
        <AnalyticsInitializer />
        <Routes>
          <Route path="/auth" element={<AuthLayout />} />
          <Route path="*" element={<GameLayout />} />
        </Routes>
      </BrowserRouter>
    );
  };
}
